import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";

  const Filter = ({ onApply, onClear, initialFilters  }) => {

  const initialValues = {
    clinical_status: "",
    financial_status: "",
    type: "",
    apheresis_date: "",
    product: "",
    ...initialFilters
  }

  const clinicialStatusOptions = [
    { value: 1, label: 'Feasible' },
    { value: 2, label: 'Non Feasible' }
  ]

  const financialStatusOptions = [
    { value: 1, label: 'Feasible' },
    { value: 2, label: 'Non Feasible' }
  ]

  const typeOptions = [
    { value: 2, label: 'PMS' },
    { value: 3, label: 'Commercial' },
    { value: 1, label: 'Trial' },
  ]

  // const productOptions = [
  //   { value: 'bcma', label: 'BCMA' },
  //   { value: 'carT', label: 'CAR-T' }
  // ]

  const formOptions = [
    {
      label: 'Clinical Status',
      type: 'checkbox',
      name: 'clinical_status',
      options: clinicialStatusOptions
    },
    {
      label: 'Financial Status',
      type: 'checkbox',
      name: 'financial_status',
      options: financialStatusOptions
    },
    {
      label: 'Type',
      type: 'checkbox',
      name: 'type',
      options: typeOptions
    },
    {
      label: 'Apheresis Date',
      type: 'date',
      name: 'apheresis_date',
      placeholder: 'Select Date',
    },
    // {
    //   label: 'Product',
    //   type: 'select',
    //   name: 'product',
    //   placeholder: 'Select Product',
    //   options: productOptions
    // }
  ]


  
  const handleSubmit = (values) => {
    onApply(values);
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmit
  })

  const handleClear = () => {
    formik.resetForm();
    onClear();
  };

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        {formOptions.map((props, key)=>(
          <Grid key={key} item xs={12}>
          <FormikControl formik={formik} {...props} />
          </Grid>
        ))}
        
        <Box sx={{ display: "flex",justifyContent: "space-between", gap: 2, marginTop: "10px" }}>
            <LoadingButton size="large" sx={{ borderRadius: "6px" }}  onClick={handleClear} variant="outlined">Clear Filter</LoadingButton>
            <LoadingButton size="large" sx={{ borderRadius: "6px" }}  type="submit" variant="contained">Apply Filter</LoadingButton>
          </Box>
      </form>
    </Box>
  );
}

export default Filter;